// app/javascript/utils/api.js
export function fetchWithLocale(url, options = {}) {
    const locale = document.documentElement.lang || "es"; // Detectar del <html lang="...">
    const separator = url.includes("?") ? "&" : "?";
    return fetch(`${url}${separator}locale=${locale}`, options);
}